import { put, takeLatest, call } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';
import routes from '../../../routes';

export function* putChangePassword({ payload }) {
  try {
    const { data, status } = yield call(api.auth.changePassword, {
      password: payload.password,
      token: payload.token,
    });
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CHANGE_PASSWORD_SUCCESS, payload: data });
    notification({
      type: 'success',
      message: 'Success. You have recovered the password successfully',
    });
    payload.history.push(routes.Auth.Login.path);
  } catch (error) {
    yield put({ type: types.CHANGE_PASSWORD_FAILURE });
    if (error?.response?.status === 401) return;
    console.dir(error);
  }
}

export function* watcherChangePassword() {
  yield takeLatest(types.CHANGE_PASSWORD_START, putChangePassword);
}
